import React, { Component } from "react";
import { Button } from "../../../common/Button/Button";
import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer"
import moment from 'moment';

class SelectServiceRequestStatusDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title
    };
  }

  

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        document.addEventListener("click", this.close);
      } else {
        document.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (e) => {
    if(this.dropdownStatus.contains(e.target)){
      return
    }
    this.setState({
      listOpen: false
    });
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  renderServiceRequestStatus = () => {
    // const {auditLog = []} = this.props;
      return(
        <div><CheckBoxContainer showSelectAll={false} toggleSelection={this.props.toggleStatusSelection}  checkboxItemsList={this.props.checkboxItemsList}/></div>
      )
    
  }


  
  render() {
    const { listOpen } = this.state;
    return (
      <div ref={elem => this.dropdownStatus = elem}>
        <Button className="inline-button" onClick={() => this.toggleList()}>Select Service Requests Status</Button>
        {listOpen && (
          <div className="dd-list selectServiceType">
            <div>
              {this.renderServiceRequestStatus()}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SelectServiceRequestStatusDropdown;
